import React from "react-dom";
import { Container, Spinner } from "react-bootstrap";
import DepartureBarChart from "./DepartureBarChart";
import { memo } from "react";

const getDayFromDate = (date) => {
    const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
    };
    let d = new Date(date);
    return d.toLocaleDateString("de-AT", options);
};

// this component is memoized with 'React.memo', therefore PopupContent only re-renders if the props change.
const PopupContent = memo(({ popupInfo }) => {
    return (
        <div className="popup-container">
            <div className="my-popup">
                <h5>{popupInfo.title} am {getDayFromDate(popupInfo.queryDate)}</h5>
                {popupInfo.chartData ?
                    <DepartureBarChart
                        chartData={popupInfo.chartData}
                    /> :
                    <Container>
                        <div className="d-flex align-items-center">
                            <Spinner animation="grow" size="sm" />
                            <b className="mx-2">Suche...</b>
                        </div>
                    </Container>}

            </div>
        </div>
    );
});


export default PopupContent;


